import { HostedFieldAction } from '../interface/messaging.interface.js';

function isFieldMessageEvent(event) {
    return event.data && Object.values(HostedFieldAction).includes(event.data.action);
}

export { isFieldMessageEvent };
